<template>
  <SDeactivatedUser />
</template>

<script lang="ts">
import type { NavigationGuardNext, Route } from 'vue-router';

export default {
  name: 'DeactivatedUserPage',
  beforeRouteEnter(to: Route, _from: Route, next: NavigationGuardNext) {
    if (to.params?.isAuthFailed) {
      next();
    } else {
      // redirect to home page
      next('');
    }
  },
};
</script>

<script setup lang="ts">
import { SDeactivatedUser } from '@slg/web-customer-shared';
</script>
